<template>
  <svg
    viewBox="0 485 1920 112"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m1920.27 548.11-.68.74c-32.96-30.24-69.56-49.7-108.77-57.84-39.22-8.14-82.17-5.19-127.66 8.76-32.19 9.88-58.06 20.7-83.08 31.17-80.51 33.69-144.1 60.31-342.27 18.02-149.03-31.8-228.19-12.19-319.86 10.52-67.05 16.61-143.04 35.44-259.04 36.92-4.32.06-8.61.08-12.81.08-155.82 0-227.1-37.39-284.69-67.6-38.72-20.31-72.16-37.85-121.24-37.85-81.8 0-169.29 19.48-260.05 57.89l-.39-.92c90.88-38.47 178.5-57.97 260.44-57.97 49.32 0 82.86 17.59 121.7 37.96 59.04 30.97 132.52 69.51 297.03 67.4 115.88-1.48 191.82-20.29 258.81-36.89 91.78-22.74 171.05-42.37 320.31-10.52 197.85 42.22 261.32 15.66 341.67-17.97 25.04-10.48 50.94-21.32 83.17-31.21 45.65-14.01 88.77-16.96 128.15-8.79 39.4 8.19 76.16 27.73 109.26 58.1z"
    />
  </svg>
</template>
